export const LIVE_TRANSLATE_SETTING_CONTROL_SIZE = 1;
export const LIVE_TRANSLATE_SETTING_LIMIT_SIZE_DOWN = 11;
export const LIVE_TRANSLATE_SETTING_LIMIT_SIZE_UP = 20;
export const LIVE_TRANSLATE_SETTING_CONTROL_SYNC = 0.5;
export const LIVE_TRANSLATE_SETTING_LIMIT_SYNC_DOWN = -10;
export const LIVE_TRANSLATE_SETTING_LIMIT_SYNC_UP = 20;
export const LIVE_TRANSLATE_LIMIT_LENG = 200;
export const LIVE_TRANSLATE_SCROLL_MARGIN_END = 20;
export const LIVE_CHAT_TEXTAREA_MAX_LENGTH = 60;
export const LIVE_CHAT_SLIDE_COUNT_EMOTICON= 5;
export const LIVE_CHAT_SLIDE_COUNT_SCHEDULE= 3;
export const LIVE_CHAT_SLIDE_WIDTH_EMOTICON= 305;
export const LIVE_CHAT_SLIDE_WIDTH_SCHEDULE= 400;